
import { Component, Vue } from 'vue-property-decorator'

@Component({})
export default class HeaderComponent extends Vue {
  get activeIndex() {
    const path = this.$route.path
    if (path === '/' || path.startsWith('/shop')) return '/'
    return path
  }
  menuIsActive = false
  windowWidth = 0
  windowWidthFlag = true
  lang: string = localStorage.getItem('preferredLanguage') || 'ua'

  menuItems = [
    { path: '/', labelKey: 'menu.shop' },
    { path: '/batteries', labelKey: 'menu.batteries' },
    { path: '/service', labelKey: 'menu.service' },
    { path: '/contact', labelKey: 'menu.contact' },
    { path: '/blog', labelKey: 'menu.blog' },
  ]

  menuNav() {
    this.menuIsActive = !this.menuIsActive
    if (this.menuIsActive) {
      const scrollbarWidth =
        window.innerWidth - document.documentElement.clientWidth
      document.body.style.overflow = 'hidden'
      document.body.style.paddingRight = scrollbarWidth + 'px'
    } else {
      document.body.style.overflow = ''
      document.body.style.paddingRight = ''
    }
  }

  switchLang() {
    this.$i18n.locale = this.lang
    localStorage.setItem('preferredLanguage', this.lang)
  }

  getWindowWidth() {
    this.windowWidth = document.documentElement.clientWidth
    this.windowWidthFlag = this.windowWidth > 960
    if (this.windowWidthFlag && this.menuIsActive) {
      this.menuIsActive = false
      document.body.style.overflow = ''
      document.body.style.paddingRight = ''
    }
  }

  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.getWindowWidth)
      this.getWindowWidth()
    })
  }

  beforeDestroy() {
    window.removeEventListener('resize', this.getWindowWidth)
    document.body.style.overflow = ''
    document.body.style.paddingRight = ''
  }
}
